var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Forma 1",
  d: "M23.73 9.213a1.3 1.3 0 0 1 .27.8 1.277 1.277 0 0 1-.27.791 54.58 54.58 0 0 1-9.69 8.978 1.263 1.263 0 0 1-1.3.061 1.285 1.285 0 0 1-.67-1.126v-4.464c-2.76-.472-10.51-.606-10.96-.933C.45 12.846 0 11.298 0 10.015a4.212 4.212 0 0 1 1.11-3.121c.46-.322 8.2-.648 10.96-1.116V1.3a1.286 1.286 0 0 1 .67-1.127 1.25 1.25 0 0 1 1.3.065 54.862 54.862 0 0 1 9.69 8.975z",
  fill: "#fff",
  fillRule: "evenodd"
})));
export default SvgRightArrow;